// Labels match Andrew Hurley's wording exactly (email 2026-09-10): the
// section itself is now "Cause", so the word "fault" is dropped from every
// option label. The `value`s are unchanged API enum keys (`fault_attribution`
// on the server) — only the display label changed, plus the addition of
// `design_team_fault`. Order follows Andrew's email, not the server enum's
// integer order (the API PR appends design_team_fault: 5 at the end of the
// enum to avoid renumbering a live production column; that integer mapping
// is independent of this display order).
export const DELAY_FAULT_ATTRIBUTIONS = [
  { value: 'owner_fault', label: 'Owner' },
  { value: 'contractor_fault', label: 'Contractor' },
  { value: 'design_team_fault', label: 'Design Team' },
  { value: 'third_party_fault', label: 'Third Party' },
  { value: 'no_fault', label: 'No Fault' },
  { value: 'force_majeure', label: 'Force Majeure' },
];

export const DELAY_STATUSES = [
  { value: 'open', label: 'Open' },
  { value: 'acknowledged', label: 'Acknowledged' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'disputed', label: 'Disputed' },
];

export const DELAY_DEFAULT_FILTERS = {
  page: 1,
  pageSize: 20,
  search: null,
  project_site_id: null,
  fault_attribution: null,
  status: null,
};

export const DELAY_DEFAULT_FORM = {
  id: null,
  title: '',
  description: '',
  date_occurred: null,
  // date_logged is never collected, submitted, or displayed in this form —
  // the API auto-populates it on create and it is no longer shown read-only
  // either (Andrew Hurley, 2026-09-10: "this field should populate
  // automatically", read as "and the form should stop showing it"). Kept
  // here only for shape consistency with the API response; nothing in
  // ProjectDelayTracker.js reads it anymore.
  date_logged: null,
  // impact_days is the *Estimated* Impact Days field in the UI. The API
  // column name is unchanged (deliberately — it's a live production
  // column), only its label and required-ness changed. null/blank means
  // "TBD" and is distinct from 0, which is a real, meaningful value (a
  // logged delay that did not slip the schedule).
  impact_days: null,
  // New field: Actual Impact Days, bound to the API's actual_impact_days
  // column. Optional, independent of impact_days.
  actual_impact_days: null,
  fault_attribution: 'third_party_fault',
  status: 'open',
  cost_impact: null,
  currency: 'USD',
  notes: '',
  project_site_id: null,
  responsible_company_id: null,
  responsible_label: '',
  responsible_external: false,
  documents: [],
  images: [],
  ccs: [],
  deleted_documents: [],
  deleted_images: [],
  errors: {},
};

export const DELAY_FAULT_VALUES = DELAY_FAULT_ATTRIBUTIONS.map((o) => o.value);
export const DELAY_STATUS_VALUES = DELAY_STATUSES.map((o) => o.value);
